module.exports = __webpack_public_path__ + "media/images/kids14-908b6958094e64d84a3d12323d954c33.jpg";